/**
 * @file Contém as constantes da aplicacao
 */
import sistema from "./sistema";
import usuario from "./usuario";

const constantes = Object.freeze({
    LOCALE: 'pt-BR',
    BASE_URL: window.location.protocol+'//'+window.location.host,
    sistema,
    usuario
});

export default constantes;
